import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['sidebar']

  get className () {
    return this.element.dataset.classname
  }

  connect () {
    this.scrollToActiveItem()
  }

  scrollToActiveItem () {
    const activeItem = this.sidebarTarget.getElementsByClassName(`${this.className}::active`)[0]
    if (this.sidebarTarget && activeItem) {
      const sidebarInner = this.sidebarTarget.getElementsByClassName(`${this.className}::app-sidebar-inner`)[0]
      sidebarInner.scrollTop = this.getOffsetTop(activeItem) - 100
    }
  }

  getOffsetTop (element) {
    const rect = element.getBoundingClientRect()
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop
    return rect.top + scrollTop
  }
}
